module.exports = __webpack_public_path__ + "media/images/emblems/Sargans-coat_of_arms-dd63848a6bccb8a04dd43cae8cbb530b.svg";